import { useEffect, useState } from 'react'
import './App.css'
import { Button, Card, Input, notification } from 'antd'
import PaymentForm from './paymentForm';

const App = () => {
  const [password, setPassword] = useState("");
  const [login, setLogin] = useState(false)

  useEffect(() => {
    let auth = sessionStorage.getItem("auth")
    if (auth && Number(auth) === 1) setLogin(true)
  }, [])

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  // Inline styles
  const styles = {
    body: {
      backgroundColor: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100vw",
      margin: 0,
    },
    loginContainer: {
      padding: "2rem",
      borderRadius: "1rem",
      textAlign: "center",
    },

  };

  const handleLogin = async () => {
    if (password === "santendaR" || password === "abhishek") {
      setLogin(true)
      sessionStorage.setItem("auth", 1)
      setPassword("")
    } else {
      notification.error({
        message: "Please enter valid password"
      })
    }
  }

  return (
    <div>
      {login
        ?
        <PaymentForm handleSignout={() => { setLogin(false); sessionStorage.clear(); }} setLogin={() => setLogin(true)} />
        :
        <div style={styles.body}>
          <Card style={styles.loginContainer} hoverable>
            <div style={{ margin: "0 0 " }}>
              <img src="https://assets.elabs.technology/web-framework/images/logo/default.jpg" alt="Estea Logo" style={{ height: "4rem" }} />
            </div>

            <Input type='password' placeholder='Enter your password' size='large' required value={password} onChange={handlePasswordChange} onPressEnter={handleLogin} style={{ margin: "2rem 0" }} />
            <Button type="primary" size='large' block onClick={handleLogin} >
              Login
            </Button>
          </Card>
        </div>
      }
    </div>
  )
}

export default App